import { render, staticRenderFns } from "./DisplayedProjectsOverview.vue?vue&type=template&id=1ae74105&"
import script from "./DisplayedProjectsOverview.vue?vue&type=script&lang=ts&"
export * from "./DisplayedProjectsOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports